/**
 * Returns true only for finite numeric values.
 */
export function isFiniteNumber(value: unknown): value is number {
  return typeof value === 'number' && Number.isFinite(value);
}

/**
 * Clamps a number between min and max.
 */
export function clampNumber({
  value,
  min,
  max,
}: {
  value: number;
  min: number;
  max: number;
}): number {
  if (value < min) return min;
  if (value > max) return max;
  return value;
}

/**
 * Clamps an index into the valid range for a list length.
 */
export function clampIndexByListLength({
  value,
  listLength,
}: {
  value: number;
  listLength: number;
}): number {
  if (listLength <= 0) return 0;

  return clampNumber({
    value,
    min: 0,
    max: listLength - 1,
  });
}
